import PageHeader from "@/components/base/PageHeader";
import ContactForm from "@/pages/about/components/ContactForm";
import Faq from "@/pages/about/components/Faq";
import { usePageMeta } from "@/hooks/usePageMeta";

const values = [
  {
    icon: "ri-shield-star-line",
    title: "内容系统化",
    desc: "按题材、地区、年代等多维度整理剧集资料，让信息一目了然。",
  },
  {
    icon: "ri-book-open-line",
    title: "剧情有解析",
    desc: "不止于简介，我们提供分集剧情梳理，帮你跟上复杂的故事线。",
  },
  {
    icon: "ri-user-heart-line",
    title: "演员有档案",
    desc: "为主演建立资料档案与作品列表，认识每一张熟悉的面孔。",
  },
  {
    icon: "ri-flashlight-line",
    title: "动态够及时",
    desc: "汇集剧集新闻、演员动态与行业观察，紧跟影视圈最新风向。",
  },
];

export default function About() {
  usePageMeta(
    "关于我们 - 漂亮的保姆",
    "漂亮的保姆是专注影视剧资讯、剧情介绍与解析的内容网站，提供剧集资料、演员信息与最新影视动态，并欢迎通过在线表单与我们联系。",
    "漂亮的保姆,关于我们,影视剧资讯,剧情介绍,演员介绍,联系方式",
  );

  return (
    <>
      <PageHeader
        title="关于我们"
        desc="漂亮的保姆，一个专注影视剧资讯与剧情介绍的内容网站。"
        crumbs={[{ label: "首页", to: "/" }, { label: "关于我们" }]}
      />

      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-8 space-y-8">
        <section className="bg-background-50 rounded-lg border border-background-200 p-5 md:p-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
            网站简介
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-loose">
            漂亮的保姆是一个聚焦影视剧资讯与剧情介绍的内容站点。我们关注电视剧这一最贴近大众的影视形式，围绕“看什么、讲了什么、谁在演”三个核心问题，为观众提供系统化、易浏览的信息服务。
          </p>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-loose">
            无论你是想快速了解一部热播剧的剧情脉络，还是想按题材寻找下一部想追的剧，或是想认识某位演员的更多作品，都可以在这里找到对应的栏目。我们希望通过清晰的信息结构与持续更新的内容，成为你追剧路上可靠的信息入口。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
            {values.map((v) => (
              <div
                key={v.title}
                className="p-4 rounded-lg bg-background-100 border border-background-200"
              >
                <span className="w-11 h-11 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-xl mb-3">
                  <i className={v.icon} />
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  {v.title}
                </h3>
                <p className="mt-1.5 text-sm text-foreground-500 leading-relaxed">
                  {v.desc}
                </p>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-background-50 rounded-lg border border-background-200 p-5 md:p-8">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
            联系我们
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { icon: "ri-mail-line", label: "邮箱", value: "contact@pretty-nanny.example" },
              { icon: "ri-phone-line", label: "客服电话", value: "400-000-0000" },
              { icon: "ri-map-pin-line", label: "地址", value: "上海市 · 影视文化产业园" },
            ].map((c) => (
              <div
                key={c.label}
                className="flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200"
              >
                <span className="w-11 h-11 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center text-xl shrink-0">
                  <i className={c.icon} />
                </span>
                <div className="min-w-0">
                  <p className="text-xs text-foreground-400">{c.label}</p>
                  <p className="text-sm text-foreground-800 truncate">{c.value}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <ContactForm />

        <Faq />

        <section className="bg-secondary-50 rounded-lg border border-secondary-200 p-5 md:p-6">
          <h2 className="font-heading text-base font-bold text-secondary-900 mb-2 flex items-center gap-2">
            <i className="ri-error-warning-line" />
            免责声明与演示说明
          </h2>
          <p className="text-sm text-secondary-900/80 leading-relaxed">
            本网站为影视内容演示站点，页面中的剧集、演员、资讯等信息均为前端模拟数据，仅用于展示信息结构与浏览体验，不构成任何真实的内容推荐或事实陈述。搜索、筛选与收藏功能均在浏览器本地完成，不涉及真实后台接口调用。网站不提供影视播放、下载或任何交易服务。
          </p>
        </section>
      </div>
    </>
  );
}